(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shopping-cart-billing"] && !Shopify.designMode) return;
  try {
    class CartBilling extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('[data-billing-toggle]');
      this.content = this.querySelector('[data-factura-content]');
      this.inputs = this.querySelectorAll('[data-billing-input]');
      this.deseoHidden = this.querySelector('[data-deseo-hidden]');

      if (!this.checkbox || !this.content || !this.deseoHidden) return;

      this.form = this.closest('form');
      if (!this.form) {
        const formId = this.checkbox.getAttribute('form') || 'cart';
        this.form = document.getElementById(formId);
      }

      if (!this.form) return;

      this.handleToggle = this.handleToggle.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);

      this.checkbox.addEventListener('change', this.handleToggle);
      this.form.addEventListener('submit', this.handleSubmit);

      this.handleToggle();
    }

    handleToggle() {
      const enabled = this.checkbox.checked;
      this.content.classList.toggle('hidden', !enabled);

      this.inputs.forEach((input) => {
        if (enabled) {
          const name = input.getAttribute('data-name');
          if (name) {
            input.setAttribute('name', name);
          }
          input.removeAttribute('disabled');
        } else {
          input.removeAttribute('name');
          input.setAttribute('disabled', 'disabled');
          if (!input.defaultValue) {
            input.value = '';
          }
        }
      });
    }

    handleSubmit() {
      if (this.checkbox.checked) {
        this.deseoHidden.name = 'attributes[Deseo Factura]';
        this.deseoHidden.value = 'Si';
      } else {
        this.deseoHidden.removeAttribute('name');
        this.deseoHidden.value = '';
      }
    }
  }

  customElements.define('cart-billing', CartBilling);
  } catch(e) { console.error(e); }
})();

})();
